module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/783d87a11d87b2c498242905634a62e4.png";